import { Button, Popover, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const MIN_WINDOW_HOURS = 4;
const MAX_WINDOW_HOURS = 22;

export const HoursSelector = ({
  hours,
  onChange,
}: {
  hours: number;
  onChange: (hours: number) => void;
}) => {
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <>
      <Button
        sx={{
          padding: '5px 12px',
        }}
        ref={anchorRef}
        onClick={() => setPopoverOpen(true)}
        data-testid='create-backup-policy-hours-select'
        disableFocusRipple
      >
        <Typography fontWeight={600}>{`${hours} hours`}</Typography>

        <i className='material-symbols-arrow-drop-down-rounded text-[22px] ml-[4px]' />
      </Button>
      <HoursSelectorPopover
        anchorRef={anchorRef}
        hours={hours}
        onChange={(value) => {
          setPopoverOpen(false);
          onChange(value);
        }}
        popoverOpen={popoverOpen}
      />
    </>
  );
};

const HoursSelectorPopover = ({
  hours,
  onChange,
  anchorRef,
  popoverOpen,
}: {
  popoverOpen: boolean;
  hours: number;
  onChange: (hours: number) => void;
  anchorRef: React.RefObject<HTMLButtonElement | null>;
}) => {
  const [value, setValue] = useState(`${hours}`);

  useEffect(() => {
    setValue(`${hours}`);
  }, [hours]);

  return (
    <Popover
      disablePortal
      open={popoverOpen}
      anchorEl={anchorRef.current}
      onClose={() => onChange(+value)}
    >
      <Stack
        className='p-[24px] w-[308px]'
        direction='row'
        justifyContent='space-between'
      >
        <Typography variant='subtitle1' className='mt-[4px] w-[100px]'>
          {`Start time range (${MIN_WINDOW_HOURS}-${MAX_WINDOW_HOURS} hours)`}
        </Typography>
        <TextField
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onBlur={() => {
            if (+value < MIN_WINDOW_HOURS) {
              setValue(`${MIN_WINDOW_HOURS}`);
            } else if (+value > MAX_WINDOW_HOURS) {
              setValue(`${MAX_WINDOW_HOURS}`);
            }
          }}
          type='number'
          inputProps={{
            min: MIN_WINDOW_HOURS,
            max: MAX_WINDOW_HOURS,
            step: 1,
            pattern: '[0-9]*',
            inputMode: 'numeric',
          }}
          sx={{
            width: '80px',

            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
              {
                display: 'none',
              },
            '& input[type=number]': {
              MozAppearance: 'textfield',
            },

            '& .MuiInputBase-root': {
              padding: 0,
              fontSize: '13px',
            },

            '& .MuiOutlinedInput-input': {
              padding: '4px 12px',
            },

            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid var(--mui-palette-primary-main)',
            },
          }}
        />
      </Stack>
    </Popover>
  );
};
